/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { FaArrowCircleLeft } from 'react-icons/fa';
import { MdCancel } from 'react-icons/md';
import Col from 'react-bootstrap/Col';
import { useTheme } from '../../../../providers/theme';
import * as S from './style';

export interface IProgressBar {
  progressBarSteps?: string[];
  stepsTitle?: string;
  totalSteps: number;
  activeStep: number;
  isGoBackDisabled?: boolean;
  onCloseClick?(): void;
  onActiveStepChange(step?: number): void;
}

export const ProgressBar = (props: IProgressBar) => {
  const theme = useTheme();
  const {
    progressBarSteps,
    stepsTitle,
    totalSteps,
    activeStep,
    onCloseClick,
    isGoBackDisabled,
    onActiveStepChange,
  } = props;

  let fillerWidth = (100 / totalSteps) * activeStep;

  const onPreviousClick = () => {
    onActiveStepChange && onActiveStepChange();
  };

  return (
    <>
      <S.Container>
        <S.HeaderRow>
          <Col lg={1} xs={2}>
            <S.Previous
              disabled={isGoBackDisabled}
              onClick={() => {
                if (!isGoBackDisabled) onPreviousClick();
              }}
            >
              <FaArrowCircleLeft />
            </S.Previous>{' '}
          </Col>
          <Col lg={5} xs={8}>
            <S.Heading>{progressBarSteps?.[activeStep]} </S.Heading>
          </Col>
          <Col lg={5} className="d-sm-block">
            <S.Step>
              {stepsTitle} {activeStep + 1} out of {totalSteps + 1}
            </S.Step>
          </Col>
          <Col lg={1} xs={2}>
            <S.Cancel onClick={onCloseClick}>
              <MdCancel />
            </S.Cancel>
          </Col>
        </S.HeaderRow>
        <S.Containers>
          <S.FillerStyle fillWidth={fillerWidth} color={'#104382'} />
        </S.Containers>
      </S.Container>
    </>
  );
};
ProgressBar.defaultProps = {
  progressBarSteps: [
    '',
    'Dependents',
    'Education',
    'Employment',
    'Caribbean Community State',
    'Documents in support of Application',
  ],
  stepsTitle: 'Step',
  totalSteps: 6,
  activeStep: 5,
};
